<script setup lang="ts">
import { computed } from 'vue'
import { LoaderDotsVariant } from './types'

interface Props {
  variant?: keyof typeof LoaderDotsVariant
}

const props = withDefaults(defineProps<Props>(), {
  variant: LoaderDotsVariant.default,
})

const variantClass = computed(() => {
  switch (props.variant) {
    case LoaderDotsVariant.white:
      return 'bg-white animate-pulsing-white'
    default:
      return 'bg-gray-400 animate-pulsing-gray'
  }
})
</script>

<template>
  <div class="flex items-center py-1">
    <span
      v-for="index in 3"
      :key="`loader-dot-${index}`"
      :style="{ 'animation-delay': `${index * 200}ms` }"
      :class="variantClass"
      class="mx-0.5 inline-block size-2 rounded-full"
    />
  </div>
</template>
